import { useState } from "react";
import { toast } from "sonner";
import { cnpjDigits, formatCep, formatCnpj, isValidCnpj, lookupCep, lookupCnpj } from "./empresaHelpers";

// Auto-preenchimento por CNPJ (BrasilAPI) e CEP (ViaCEP) no formulário da empresa.
export function useCnpjCepLookup(f, set) {
  const [cepLoading, setCepLoading] = useState(false);
  const [cnpjLoading, setCnpjLoading] = useState(false);

  const onCnpjChange = (v) => set({ cnpj: formatCnpj(v) });
  const buscarCnpj = async () => {
    if (cnpjDigits(f.cnpj).length !== 14) return toast.error("CNPJ deve ter 14 dígitos");
    if (!isValidCnpj(f.cnpj)) return toast.error("CNPJ inválido (dígito verificador não confere)");
    setCnpjLoading(true);
    const d = await lookupCnpj(f.cnpj);
    setCnpjLoading(false);
    if (!d) return toast.error("CNPJ não encontrado");
    const endereco = [d.logradouro && `${d.logradouro}${d.numero ? `, ${d.numero}` : ""}`, d.bairro, d.municipio, d.uf].filter(Boolean).join(", ");
    set((prev) => ({
      nome: prev.nome || d.razao_social || d.nome_fantasia || prev.nome,
      cep: prev.cep || formatCep(d.cep || ""),
      endereco: endereco || prev.endereco,
      telefone: prev.telefone || d.ddd_telefone_1 || "",
      email: prev.email || d.email || "",
    }));
    toast.success("Dados da empresa preenchidos");
  };
  const onCnpjBlur = () => { if (cnpjDigits(f.cnpj).length === 14 && isValidCnpj(f.cnpj) && !f.nome) buscarCnpj(); };

  const onCepChange = (v) => set({ cep: formatCep(v) });
  const buscarCep = async () => {
    if ((f.cep || "").replace(/\D/g, "").length !== 8) return toast.error("CEP deve ter 8 dígitos");
    setCepLoading(true);
    const d = await lookupCep(f.cep);
    setCepLoading(false);
    if (!d) return toast.error("CEP não encontrado");
    set({ endereco: [d.logradouro, d.bairro, d.localidade, d.uf].filter(Boolean).join(", ") });
    toast.success("Endereço preenchido");
  };
  const onCepBlur = () => { if ((f.cep || "").replace(/\D/g, "").length === 8 && !f.endereco) buscarCep(); };

  const cnpjInvalido = cnpjDigits(f.cnpj).length === 14 && !isValidCnpj(f.cnpj);
  return { cepLoading, cnpjLoading, cnpjInvalido, onCnpjChange, buscarCnpj, onCnpjBlur, onCepChange, buscarCep, onCepBlur };
}
